import type { SupportedThemes, TextToken, Theme } from '@core/theme-legacy';

type AvatarSpecificTokenExtract<T> = Extract<T, `colorAvatar${string}`>;
type ExtractedAvatarToken = AvatarSpecificTokenExtract<keyof Theme>;

export type AvatarToken = ExtractedAvatarToken extends never
  ? AvatarSpecificTokenExtract<keyof typeof SupportedThemes.light>
  : ExtractedAvatarToken;

export type AvatarsTokens = {
  backgroundColor: AvatarToken;
  color: TextToken;
};

export const avatarTokenSet: AvatarsTokens[] = [
  {
    backgroundColor: 'colorAvatarSteelLighter',
    color: 'colorTextPrimaryDefault',
  },
  {
    backgroundColor: 'colorAvatarSteelLight',
    color: 'colorTextPrimaryDefault',
  },
  {
    backgroundColor: 'colorAvatarSteelDark',
    color: 'colorTextOnprimaryDefault',
  },
  {
    backgroundColor: 'colorAvatarGreen',
    color: 'colorTextOncomponentDefault',
  },
  {
    backgroundColor: 'colorAvatarPink',
    color: 'colorTextOncomponentDefault',
  },
  {
    backgroundColor: 'colorAvatarPurple',
    color: 'colorTextOncomponentDefault',
  },
  {
    backgroundColor: 'colorAvatarYellow',
    color: 'colorTextOncomponentDefault',
  },
  {
    backgroundColor: 'colorAvatarOrange',
    color: 'colorTextOncomponentDefault',
  },
];
